
import {
  computed,
  defineComponent, ref, watch,
} from 'vue';
import OverlayPanel from 'primevue/overlaypanel';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'SpmOverlayPanel',

  components: {
    OverlayPanel,
  },

  props: {
    classTrigger: {
      type: String,
      required: false,
      default: '',
    },

    classHeader: {
      type: String,
      required: false,
      default: '',
    },

    classContent: {
      type: String,
      required: false,
      default: '',
    },

    classFooter: {
      type: String,
      required: false,
      default: '',
    },

    closeOnRouteChange: {
      type: Boolean,
      required: false,
      default: true,
    },

    minPanelWidth: {
      type: String,
      required: false,
      default: '240px',
    },

    maxPanelWidth: {
      type: String,
      required: false,
      default: '',
    },

    styleOverlayPanel: {
      type: String,
      required: false,
      default: '',
    },

    closePanel: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  emits: ['onclose-panel'],

  setup(props, context) {
    const op = ref();
    const toggle = (event: Event) => op.value.toggle(event);
    const currentRoute = computed(() => useRoute());

    watch(() => currentRoute.value.name, () => {
      // if route changes, close the overlay panel
      if (props.closeOnRouteChange) {
        op.value.hide();
      }
    });

    watch(() => props.closePanel, () => {
      if (props.closePanel) {
        op.value.hide();
        context.emit('onclose-panel');
      }
    });

    const onHide = () => {
      if (props.closePanel) {
        context.emit('onclose-panel');
      }
    };

    const getOverlayEl = (): HTMLElement | null => {
      // PrimeVue exposes container on OverlayPanel instance
      const el = op.value?.container;
      if (el && el.nodeType === 1) return el;
      // Fallback: query visible overlay panels in DOM
      const panels = document.querySelectorAll('.p-overlaypanel');
      for (let i = 0; i < panels.length; i++) {
        const panel = panels[i] as HTMLElement;
        if (panel.offsetWidth > 0 && panel.offsetHeight > 0) {
          return panel;
        }
      }
      return null;
    };

    const onShow = () => {
      setTimeout(() => {
        const el = getOverlayEl();
        if (el) {
          const top = parseFloat(el.style.top) || 0;
          const left = parseFloat(el.style.left) || 0;
          el.style.position = 'fixed';
          el.style.top = `${top - window.scrollY}px`;
          el.style.left = `${left - window.scrollX}px`;
        }
      }, 10);
    };

    return {
      op,
      toggle,
      onHide,
      onShow,
    };
  },
});
